import { ChangeEvent } from 'react'

import { Input, SystemProps } from '@chakra-ui/react'

type UploadTriggerProps = {
  onChangeFile: (e: ChangeEvent<HTMLInputElement>) => Promise<void>
  accept: string
  testid: string
}

const UploadTrigger = ({
  onChangeFile,
  accept,
  testid,
}: UploadTriggerProps & SystemProps) => {
  return (
    <Input
      type="file"
      height="100%"
      width="100%"
      position="absolute"
      top="0"
      left="0"
      opacity="0"
      aria-hidden="true"
      accept={accept}
      tabIndex={-1}
      onInput={onChangeFile}
      cursor="pointer"
      data-testid={testid}
    />
  )
}

export default UploadTrigger
